import React, { useState, useEffect } from "react";
import ValidatedImage from "../../utils/ValidatedImage"
import PassportDialog from "./PassportDialog/PassportDialog"
import { CircularProgress } from '@material-ui/core';
import axios from "axios";
import { useTranslation } from "react-i18next";

function PassportCard(props){

    const { t } = useTranslation()

    const { passport } = props

    const [OCR, setOCR] = useState(null)
    const [OCRFront, setOCRFront] = useState(null)
    const [OCRBack, setOCRBack] = useState(null)
    const [OCRFileType, setOCRFileType] = useState(null)
    const [OCRPictureOpen, setOCRPictureOpen] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (passport.ocr_key){
                axios.get('/dash/ocr/' + passport.ocr_key).then( response=> {
                    let hasPDF = response.data.pdf || response.data.file_metadata?.file_type === "pdf"
                    if (hasPDF) {
                        setOCRFileType("pdf");
                    } else {
                        setOCRFileType("image");
                    }
                    let ocr_data = response.data.processed_object
                    setOCR(ocr_data != null ? ocr_data : {});
                }).catch(error => {
                    setOCR(undefined)
                })
            }
            else{
                if (passport.ocr_front_key) {
                    axios.get('/dash/ocr/' + passport.ocr_front_key).then( response => {
                        let hasPDF = response.data.pdf || response.data.file_metadata?.file_type === "pdf"
                        if (hasPDF) {
                            setOCRFileType("pdf");
                        } else {
                            setOCRFileType("image");
                        }
                        let ocr_data_front = response.data.processed_object
                        setOCRFront(ocr_data_front != null ? ocr_data_front : {});             
                    }).catch(error => {
                        setOCRFront(undefined)
                    })
                }

                if (passport.ocr_back_key) {
                    axios.get('/dash/ocr/' + passport.ocr_back_key).then( response => {
                        let hasPDF = response.data.pdf || response.data.file_metadata?.file_type === "pdf"
                        if (hasPDF) {
                            setOCRFileType("pdf");
                        } else {
                            setOCRFileType("image");
                        }
                        let ocr_data_back = response.data.processed_object
                        setOCRBack(ocr_data_back != null ? ocr_data_back : {});             
                    }).catch(error => {
                        setOCRBack(undefined)
                    })
                }
            }
        }, 500);
        return () => {
            clearTimeout(timer)
        }
    }, [passport])

    useEffect(() => {
        if (OCRFront !== null || OCRBack!== null){
            if (OCRFront && OCRBack) {
                let ocr_data_joined = {...OCRFront,...OCRBack}
                setOCR(ocr_data_joined)
                }
            else if (OCRFront) setOCR(OCRFront)
            else if (OCRBack)  setOCR(OCRBack)
            else setOCR(undefined)
        }
    },[OCRFront, OCRBack])

    let getPictureContent = (picture) => {
        if (picture === undefined) {
            return (          
                <div 
                    className={["labelText", "normalMediumSize"].join(" ")} 
                    style={{textAlign:"center", margin:"auto"}}
                >
                    {t("information_unavailable")}
                </div>
            )
        } 
        else{
            return (
                <ValidatedImage
                    image_key={picture}
                    dash_api_endpoint_url={'/dash/ocr/image'}
                    imageStyle = {{margin:"auto", width:"100%", height:"100%",position:"absolute", top:"-9999px",bottom:"-9999px",left:"-9999px",right:"-9999px", borderRadius: "5px", objectFit:"cover"}}
                    imageAlt = {"Foto do Documento"}
                    fileType={OCRFileType}
                />
            );
        }
    };

    if (OCR === null || OCRFileType===null) {
        return (
            <div style={{minHeight: "250px"}} className="analysisCard">
                <div className={["blueText", "subtitleSize"].join(" ")}>{t("Passaporte OCR")}</div>
                <div style={{display:"flex", flexGrow:"1"}}>
                    <CircularProgress style={{margin:"auto"}} />
                </div>
            </div>
        );    
    }
    else if (OCR === undefined || OCRFileType===undefined){
        return (
            <div style={{minHeight: "250px"}} className="analysisCard">
                <div className={["blueText", "subtitleSize"].join(" ")}>{t("Passaporte OCR")}</div>
                <div style={{display:"flex", flexGrow:"1"}}>
                    <div className={["labelText", "normalMediumSize"].join(" ")} style={{margin:"auto"}}>
                        {t("information_unavailable")}
                    </div>
                </div>
            </div>
        )
    }
    else {
        const hasAnyImage = passport.ocr_key || passport.ocr_front_key || passport.ocr_back_key;

        return (
            <div style={{ minHeight: "600px", width: "100%" }} className="analysisCard">
                <div className={["blueText", "subtitleSize"].join(" ")}>{t("Passaporte OCR")}</div>
                <div className="internalCardContainer" style={{ display: "flex", flexGrow: "1", maxHeight: "600px", flexDirection: "row", width: "100%" }}>
                    <div style={{ display: "flex", maxHeight: "64vw", flexDirection: "column", width: "100%" }}>
                        <div style={{ display: "block", width: "100%", height: "90%", margin: "0 auto", overflow: "hidden", position: "relative", alignItems: "center", justifyContent: "center", borderRadius: "5px" }}>
                            {passport.ocr_key
                                ? getPictureContent(passport.ocr_key)
                                : (passport.ocr_front_key && getPictureContent(passport.ocr_front_key))}
                        </div>
                        {hasAnyImage && (
                            <div
                                onClick={() => setOCRPictureOpen(true)}
                                className={["blueText", "normalSmallSize", "link"].join(" ")}
                                style={{ margin: "10px", textAlign: "center" }}
                            >
                                {`${t("see")} ${t(OCRFileType)}`}
                            </div>
                        )}
                    </div>
                    {hasAnyImage && (
                        <PassportDialog
                            open={OCRPictureOpen}
                            onClose={() => setOCRPictureOpen(false)}
                            image_list={passport.ocr_key ? [passport.ocr_key] : [passport.ocr_front_key, passport.ocr_back_key]}
                            fileType={OCRFileType}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default PassportCard